<template>
  <div class="detail">
    <div class="detail-banner">
      <img :src="fileUrl+banner.img" alt="">
      <div>{{banner.title}}</div> 
    </div> 
    <div class="detail-content">
      <div class="detail-content-nav">
        <!-- <div @click="goBack" v-if="show">首页</div> -->
        <div @click="goBack">新闻中心</div>
        <div>&gt;</div>
        <div class="detail-content-nav-title">{{detail.title}}</div>
      </div>
      <div class="detail-content-title">{{detail.title }}</div>
      <div class="detail-content-time">日期：{{detail.year}}-{{detail.month}}-{{detail.day}}</div>
      <div v-if="detail.content" v-html="detail.content"></div>
      <div v-else class="detail-content-nodata">暂无详情</div>
    </div>  
    
  </div>
</template>

<script>
import { mapState} from 'vuex'
import * as API from '../api/api'
export default {
  computed: {
    ...mapState({fileUrl:state => state.fileUrl})
  },
  data(){
    return{   
      banner:{},
      defaultTitle:'关注互联网，关注吉埃思',
      defaultImg:require('../assets/img/new_banner.png'),
      detail:{}
    }
  },
  mounted(){
     window.scrollTo(0,0);
    if(this.$route.params.detail===undefined){
      this.$router.push({name:'news'})
      return 
    }
    console.log(this.$route.params.detail);
    this.detail=this.$route.params.detail
    this.getBanner()
  },
  methods:{
    // 获取轮播图
    getBanner(){
      let that=this
      API.getBanner(4).then(res=>{
        if (res&&res.data) {
          that.banner={
            title:res.data.title,
            img:res.data.imgs.length>0 ? res.data.imgs[0] : that.defaultImg
          }
        }else{
          that.banner={
            title:that.defaultTitle,
            img:that.defaultImg
          }
        }
        
      })
    },
    goBack(){
      this.$router.push({name:'news'})
    } , 
  }
}
</script>

<style lang="scss" scoped>
  .detail{    
    width: 100%;
    margin: auto;
    &-banner{
      width: 100%;
      height: 4.4rem;
      position: relative;
      >img{
        width: 100%;
        height: 100%;
      }
     >div{
        position: absolute;
        left: 0;
        right: 0;
        top:2.4rem;
        margin: auto;
        font-size: 0.38rem;
        color: #AEB8BF;
        text-align: center;
      }
    }
    &-content{
      width: 12rem;
      margin: auto;
      &-nav{
        display: flex;
        align-items: center;
        margin-top: 0.4rem;
        >div{
          margin: 0 0.1rem; 
          color: #555555;
          font-size: 0.24rem;         
        }
        >div:nth-child(1){
          cursor: pointer;        
        }
        >div:nth-child(1):hover{
          color: #FFBE00;
        }   
        &-title{
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          max-width: 9rem;
        }  
      }
      &-title{
        color: #555;
        font-size: 0.38rem;
        text-align: center;
        font-weight: 400;
        margin-top: 0.8rem;
      }
      &-time{
        color: #555;
        font-size: 0.24rem;
        text-align: center;
        font-weight: 400;
        margin-top: 0.3rem;
      }
      &-nodata{
        margin-top: 0.5rem;
        text-align: center;
      }
    }
    
  }
</style>